import { Module, GetterTree, MutationTree, ActionTree } from "vuex";
import { SOURCE } from "@/modules/campos_novos/settings";
import { simulator } from "./simulator";

export interface ICamposNovosState {}

const initialState: ICamposNovosState = {};

const mutations: MutationTree<ICamposNovosState> = {};

const actions: ActionTree<ICamposNovosState, any> = {
    async initialize({ dispatch }) {
        await dispatch("common/initialize", SOURCE, {
            root: true
        });
    }
};

const getters: GetterTree<ICamposNovosState, any> = {
    needInitialize(state, getters, rootState, rootGetters) {
        const needInitializeList = [rootGetters["common/needInitialize"]];
        return needInitializeList.some(item => item);
    }
};

export const camposNovos: Module<ICamposNovosState, any> = {
    namespaced: true,
    state: initialState,
    mutations,
    actions,
    getters,
    modules: {
        simulator
    }
};
